module.exports = __webpack_public_path__ + "img/vegetable-kale-190x100.83e9579c.jpg";